import { render } from "./DocumentsListModal.vue?vue&type=template&id=d2f7c734"
import script from "./DocumentsListModal.vue?vue&type=script&lang=js"
export * from "./DocumentsListModal.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Intermark\\Intermark(mobile)\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__